import { v4 as uuid } from 'uuid';
import { ELEMENTS } from 'Editor/services/consts';
import DOMNormalizer from 'Editor/services/DOMUtilities/DOMNormalizer/DOMNormalizer';

/**
 * @deprecated start using EditorDOMUtils, if function does not exist port it and refactor it
 */
class DOMUtils {
  static WORD_REGEX =
    /[a-z\-\u0027\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+('[a-z\-\u0027\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+)*/gi;

  // list of default text elements
  static BLOCK_TEXT_ELEMENTS = ['PARAGRAPH-ELEMENT'];

  static BLOCK_FRONTEND_ONLY_ELEMENTS = [
    ELEMENTS.InvalidElement.ELEMENT_TYPE,
    ELEMENTS.LoaderElement.ELEMENT_TYPE,
    'STYLE',
  ];

  static BLOCK_INVALID_ELEMENTS = ['INVALID-ELEMENT', 'LOADER-ELEMENT'];

  static BLOCK_NON_EDITABLE_ELEMENTS = [
    ...DOMUtils.BLOCK_INVALID_ELEMENTS,
    'PAGE-BREAK-ELEMENT', // legacy
    'SECTION-BREAK-ELEMENT', // legacy
    'TABLE-OF-CONTENTS-ELEMENT',
    'LIST-OF-FIGURES-ELEMENT',
    'LIST-OF-TABLES-ELEMENT',
    'KEYWORDS-ELEMENT',
    'AUTHORS-ELEMENT',
  ];

  // list of editable level0 elements
  static EDITABLE_LEVEL0_ELEMENTS = [
    'PARAGRAPH-ELEMENT',
    'TABLE',
    'FIGURE-ELEMENT',
    'TRACK-INS-ELEMENT',
    'TRACK-DEL-ELEMENT',
    ELEMENTS.ReferencesSectionElement.TAG,
    ELEMENTS.TableOfLabelsElement.TAG,
  ];

  // list of deletable level0 elements
  static DELETABLE_LEVEL0_ELEMENTS = [
    ...DOMUtils.EDITABLE_LEVEL0_ELEMENTS,
    ...DOMUtils.BLOCK_NON_EDITABLE_ELEMENTS,
  ];

  static BLOCK_ELEMENTS = [
    ...DOMUtils.DELETABLE_LEVEL0_ELEMENTS,
    'APPROVED-ELEMENT',
    'READONLY-ELEMENT',
    'REDACTED-ELEMENT',
  ];

  static MULTI_BLOCK_CONTAINER_ELEMENTS = [
    ELEMENTS.ReferencesSectionElement.TAG,
    ELEMENTS.TableOfLabelsElement.TAG,
    'TD',
  ];

  static BLOCK_CONTAINER_ELEMENTS = [
    ...DOMUtils.MULTI_BLOCK_CONTAINER_ELEMENTS,
    ELEMENTS.TrackInsertElement.TAG,
    ELEMENTS.TrackDeleteElement.TAG,
  ];

  static FRONTEND_CONTAINER_ELEMENTS = [ELEMENTS.PageElement.TAG, ELEMENTS.SectionElement.TAG];

  // list of splitable level0 elements
  static DEFAULT_SPLITABLE_LEVEL0_ELEMENTS = ['PARAGRAPH-ELEMENT'];

  static INLINE_FRONTEND_ONLY_ELEMENTS = [
    'BR',
    ELEMENTS.TableElement.ELEMENTS.TABLE_HEADER.TAG,
    ELEMENTS.TableElement.ELEMENTS.TABLE_HEADER_CELL.TAG,
    ELEMENTS.InvalidElement.TAG,
    'STYLE',
    'SPAN',
    'DIV',
  ];

  // list of non selectable elements
  static INLINE_NON_SELECTABLE_ELEMENTS = [
    'STYLE',
    'BR',
    'TRACK-DEL-ELEMENT',
    'EQUATION-ELEMENT',
    'PASTE-MARKER-ELEMENT',
    // 'SPAN',
    // 'DIV',
    ELEMENTS.PlaceholderElement.TAG,
    ELEMENTS.PageBreakElement.TAG,
    ELEMENTS.SectionBreakElement.TAG,
    ELEMENTS.ColumnBreakElement.TAG,
    // 'FIELD-ELEMENT',
  ];

  // list of non-editable elements that can be inside a text element
  static INLINE_NON_EDITABLE_ELEMENTS = [
    ELEMENTS.CitationsGroupElement.TAG,
    // 'CITATION-ELEMENT',
    ELEMENTS.NoteElement.TAG,
    ELEMENTS.SymbolElement.TAG,
    'PASTE-MARKER-ELEMENT',
    ELEMENTS.EquationElement.TAG,
    'INVALID-ELEMENT',
    'BR',
    ELEMENTS.PlaceholderElement.TAG,
    ELEMENTS.PageBreakElement.TAG,
    ELEMENTS.SectionBreakElement.TAG,
    ELEMENTS.ColumnBreakElement.TAG,
    ELEMENTS.TabElement.TAG,
    ELEMENTS.ImageElement.TAG,
    // 'FIELD-ELEMENT',
  ];

  // list of elements that can't have styles inside
  static INLINE_NON_STYLABLE_ELEMENTS = [
    ELEMENTS.CitationsGroupElement.TAG,
    ELEMENTS.NoteElement.TAG,
    ELEMENTS.EquationElement.TAG,
    // ELEMENTS.FieldElement.TAG,
    ELEMENTS.PlaceholderElement.TAG,
    ELEMENTS.PageBreakElement.TAG,
    ELEMENTS.SectionBreakElement.TAG,
    ELEMENTS.ColumnBreakElement.TAG,
    ELEMENTS.TabElement.TAG,
  ];

  static INLINE_TEXT_ELEMENTS = ['FORMAT-ELEMENT'];

  static INLINE_WRAP_ELEMENTS = [
    'COMMENT-ELEMENT',
    'TEMP-COMMENT-ELEMENT',
    ELEMENTS.HyperlinkElement.TAG,
    ELEMENTS.FieldElement.TAG,
  ];

  static INLINE_EDITABLE_ELEMENTS = [
    ...DOMUtils.INLINE_TEXT_ELEMENTS,
    ...DOMUtils.INLINE_WRAP_ELEMENTS,
  ];

  static INLINE_ELEMENTS = [
    ...DOMUtils.INLINE_EDITABLE_ELEMENTS,
    ...DOMUtils.INLINE_NON_EDITABLE_ELEMENTS,
  ];

  static INLINE_DOUBLE_STATE_ELEMENTS = [
    ELEMENTS.PlaceholderElement.TAG,
    ELEMENTS.PageBreakElement.TAG,
    ELEMENTS.SectionBreakElement.TAG,
    ELEMENTS.ColumnBreakElement.TAG,
  ];

  static INLINE_LAST_CHILD_ELEMENTS = [
    ELEMENTS.PageBreakElement.TAG,
    ELEMENTS.SectionBreakElement.TAG,
    ELEMENTS.ColumnBreakElement.TAG,
  ];

  static WRAPPER_LEVEL0_ELEMENTS = ['READONLY-ELEMENT', 'APPROVED-ELEMENT'];

  static ALLOWED_PARENTS_WHILE_REMOVING = [
    'COMMENT-ELEMENT',
    'TEMP-COMMENT-ELEMENT',
    ELEMENTS.HyperlinkElement.TAG,
    'PARAGRAPH-ELEMENT',
    'SPAN',
    'FORMAT-ELEMENT',
    'DIV',
    'PAGE-BREAK-ELEMENT',
    'SECTION-BREAK-ELEMENT',
    'TABLE-OF-CONTENTS-ELEMENT',
    'LIST-OF-FIGURES-ELEMENT',
    'LIST-OF-TABLES-ELEMENT',
    'KEYWORDS-ELEMENT',
    'AUTHORS-ELEMENT',
    'TABLE',
    'CAPTION',
    'TBODY',
    'TR',
    'TD',
    'FIGURE-ELEMENT',
    'IMAGE-ELEMENT',
    'IMG',
    'FIELD-ELEMENT',
    'TRACK-INS-ELEMENT',
    'TRACK-DEL-ELEMENT',
    ELEMENTS.ReferencesSectionElement.TAG,
    ELEMENTS.TableOfLabelsElement.TAG,
  ];

  static ALLOWED_CHILDREN_TO_PARSE = [
    'FORMAT-ELEMENT',
    'COMMENT-ELEMENT',
    'TEMP-COMMENT-ELEMENT',
    ELEMENTS.HyperlinkElement.TAG,
    'CITATIONS-GROUP-ELEMENT',
    'CITATION-ELEMENT',
    'NOTE-ELEMENT',
    'SYMBOL-ELEMENT',
    'CROSS-REFERENCE-ELEMENT',
    'EQUATION-ELEMENT',
    'TRACK-DEL-ELEMENT',
    'TRACK-INS-ELEMENT',
    'EQUATION-ELEMENT',
    'CAPTION',
    'TBODY',
    'TR',
    'TD',
    'IMAGE-ELEMENT',
    'IMG',
    'FIGCAPTION',
    'PARAGRAPH-ELEMENT',
    'TABLE',
    'FIGURE-ELEMENT',
    'FIELD-ELEMENT',
    'PAGE-BREAK-ELEMENT',
    'SECTION-BREAK-ELEMENT',
    ELEMENTS.ColumnBreakElement.TAG,
    'TABLE-OF-CONTENTS-ELEMENT',
    'LIST-OF-FIGURES-ELEMENT',
    'LIST-OF-TABLES-ELEMENT',
    'KEYWORDS-ELEMENT',
    'AUTHORS-ELEMENT',
    'TABLE',
    'PLACEHOLDER-ELEMENT',
    ELEMENTS.TabElement.TAG,
    ELEMENTS.ReferencesSectionElement.TAG,
    ELEMENTS.TableOfLabelsElement.TAG,
  ];

  static MEASURE_RATIO = {
    rem: {
      rem: 1,
      px: 8,
    },
    px: {
      rem: 1 / 8,
      px: 1,
      pt: 0.75,
      cm: 0.02645833,
    },
    cm: {
      cm: 1,
      pt: 28.346456693,
      px: 1 / 0.02645833,
    },
    in: {
      in: 1,
      pt: 72,
    },
    pt: {
      pt: 1,
      cm: 1 / 28.346456693,
      px: 1 / 0.75,
      in: 1 / 72,
    },
  };

  static NODES_ID_JSON_MAPPER = {};

  /**
   * convert ui measure values in px, in, cm or pt to a desired unit, default to pt
   */
  static convertUnitTo(value, originUnit, convertionUnit = 'pt', toFixed = 0) {
    if (value != null) {
      if (!originUnit && typeof value === 'string') {
        const indexOfUnit = value.search(/cm|in|pt|px/);
        if (indexOfUnit > 0) {
          originUnit = value.substring(indexOfUnit);
        }
        value = value.replace(/cm|in|pt|px/g, '');
      }

      const _value = parseFloat(value, 10);
      if (originUnit && !Number.isNaN(_value) && originUnit.match(/^(cm|in|pt|px)$/)) {
        return +(DOMUtils.MEASURE_RATIO[originUnit][convertionUnit] * _value).toFixed(toFixed);
      }
    }
    return value;
  }

  static rgbToHex(rgb) {
    if (rgb) {
      let color = rgb.replace('rgba', '').replace('rgb', '').replace('(', '').replace(')', '');

      color = color.split(',');

      const hex0 = `0${parseInt(color[0], 10).toString(16).toUpperCase()}`.slice(-2);
      const hex1 = `0${parseInt(color[1], 10).toString(16).toUpperCase()}`.slice(-2);
      const hex2 = `0${parseInt(color[2], 10).toString(16).toUpperCase()}`.slice(-2);

      return `#${hex0}${hex1}${hex2}`;
    }
    return null;
  }

  static generateRandomNodeId() {
    return `ddc${uuid()}`;
  }

  static generateUUID() {
    return uuid();
  }

  static waitForNodeToRender(elementId, filter) {
    return new Promise((resolve, reject) => {
      const poll = setInterval(() => {
        try {
          const node = document.getElementById(elementId);
          if (node) {
            if (!filter || filter(node)) {
              clearInterval(poll);
              resolve();
            }
          }
        } catch (error) {
          reject(error);
        }
      }, 1000);
    });
  }

  static appendNode(parent, node, normalize = true) {
    if (normalize) {
      DOMNormalizer.normalizeTree(node, parent.id);
    }
    parent.appendChild(node);
  }

  static replaceNode(parent, newNode, node, normalize = true) {
    // TODO: check old node permissions (copy id)
    if (normalize) {
      DOMNormalizer.normalizeTree(newNode, parent.id);
    }
    parent.replaceChild(newNode, node);
  }

  static removeAllNodeChildren(node) {
    node.innerHTML = '';
  }

  static insertNodeBefore(parent, node, before, normalize = true) {
    if (normalize) {
      DOMNormalizer.normalizeTree(node, parent.id);
    }
    parent.insertBefore(node, before);
  }

  static insertNodeAfter(parent, node, after, normalize = true) {
    if (parent) {
      if (after && after.nextSibling) {
        DOMUtils.insertNodeBefore(parent, node, after.nextSibling, normalize);
      } else {
        DOMUtils.appendNode(parent, node, normalize);
      }
    }
  }

  static isPageNode(node) {
    if (node) {
      return node.attributes.ispagenode;
    }
    return false;
  }

  /**
   * @deprecated use EditorDOMUtils.getContentContainer
   */
  static getPageNode(node) {
    if (node) {
      const closestSection = DOMUtils.closest(node, ELEMENTS.SectionElement.TAG);
      if (closestSection) {
        return closestSection;
      }
    }

    return document.querySelector('[ispagenode="true"]');
  }

  static getNode(id, page = DOMUtils.getPageNode()) {
    const node = document.getElementById(id);

    if (node && page.contains(node)) {
      return node;
    }
    return undefined;
  }

  static getBlockNode(id) {
    let node;
    node = document.getElementById(id);

    let container = DOMUtils.getPageNode(node);

    if (node?.parentNode !== container) {
      node = DOMUtils.findNodeLevel0(container, node);
    }

    return node;
  }

  static getPlatformId(element) {
    if (element && element.nodeType === Node.ELEMENT_NODE) {
      if (element.hasAttribute('enclosed_element')) {
        return element.getAttribute('enclosed_element');
      }
      return element.id;
    }
    return null;
  }

  static isNodeLevel0(node) {
    return DOMUtils.isPageNode(node.parentNode);
  }

  static parentContainsNode(parent, node) {
    return parent === node ? false : parent.contains(node);
  }

  /**
   *
   * @param {Node} node
   * @author Carlos Oliveira
   * @deprecated use typescript EditorDOMUtils
   */
  static getOffsets(reference) {
    if (reference) {
      if (reference.nodeType && reference.nodeType === 3) {
        reference = reference.parentNode;
        if (!reference) {
          return null;
        }
      }
      if (reference.nodeType && reference.nodeType === 1) {
        let top = reference.offsetTop;
        let left = reference.offsetLeft;
        const bounds = reference.getBoundingClientRect();
        let offsetParentClimber = reference.offsetParent;
        const container = DOMUtils.getPageNode(offsetParentClimber);
        while (offsetParentClimber) {
          left += offsetParentClimber.offsetLeft;
          if (container.contains(offsetParentClimber)) {
            top += offsetParentClimber.offsetTop;
          }
          offsetParentClimber = offsetParentClimber.offsetParent;
        }
        return {
          top,
          left,
          width: bounds.width,
          height: bounds.height,
        };
      }
      if (reference instanceof Range) {
        const editorRoot = document.getElementById('EditorRoot');
        const bounds = reference.getBoundingClientRect();
        const main = document.getElementById('main');
        return {
          top: bounds.top + editorRoot.scrollTop - editorRoot.offsetTop,
          left: bounds.left + main.scrollLeft * -1,
          width: bounds.width,
          height: bounds.height,
        };
      }
    }
    return null;
  }

  static getPageWidth(platform) {
    const computedStyle = getComputedStyle(DOMUtils.getPageNode());
    let pageWidth = parseFloat(computedStyle.width.replace('px'));
    if (!platform.browser.ie) {
      pageWidth =
        pageWidth -
        parseFloat(computedStyle.paddingLeft.replace('px')) -
        parseFloat(computedStyle.paddingRight.replace('px'));
    }
    return pageWidth;
  }

  /**
   * This function checks if a node has a given ancestor
   *
   * @param {DOMNode} thisNode representing the node for which we want to find
   * an ancestor
   * @param {String[] | String} ancestorTags representing the ancestor's tag
   * @param {Element= | null} pageNode page node
   * @return {HTMLElement | null}
   */
  static closest(thisNode, ancestorTags, pageNode = document.querySelector('[ispagenode="true"]')) {
    if (!thisNode) {
      return null;
    }
    let node = thisNode.nodeType === 3 ? thisNode.parentNode : thisNode;
    let ancestorTag = [];
    if (typeof ancestorTags === 'string') {
      ancestorTag = ancestorTags.split(',');
    } else if (Array.isArray(ancestorTags)) {
      ancestorTag = ancestorTags;
    }

    const numberTags = ancestorTag.length;
    let i;
    for (i = 0; i < numberTags; i += 1) {
      if (!node) {
        return null;
      }
      if (node.tagName === ancestorTag[i].trim()) {
        return node;
      }
    }
    let thisParentNode = node.parentNode;
    while (thisParentNode && thisParentNode !== pageNode) {
      for (i = 0; i < numberTags; i += 1) {
        if (thisParentNode.tagName === ancestorTag[i].trim()) {
          return thisParentNode;
        }
      }
      node = thisParentNode;
      thisParentNode = node.parentNode;
    }
    return null;
  }

  /**
   * This function checks if a node has a given ancestor
   *
   * @param {DOMNode} thisNode representing the node for which we want to find
   * an ancestor
   * @param {String} ancestorTags representing the ancestor's tag
   * @param {HTMLElement=} pageNode page node
   * @return {HTMLElement | null}
   */
  static closestWithAttribute(
    thisNode,
    attribute,
    pageNode = document.querySelector('[ispagenode="true"]'),
  ) {
    let attributesToVerify;
    if (!attribute) {
      return null;
    }
    if (typeof attribute === 'object' && !Array.isArray(attribute)) {
      attributesToVerify = [attribute];
    } else {
      attributesToVerify = attribute;
    }
    let node = thisNode;
    if (node.nodeType === 3) {
      node = node.parentNode;
    }
    if (DOMUtils.hasAtributeList(node, attributesToVerify)) {
      return node;
    }
    let thisParentNode = node.parentNode;
    while (thisParentNode && thisParentNode !== pageNode) {
      if (DOMUtils.hasAtributeList(node, attributesToVerify)) {
        return node;
      }
      node = thisParentNode;
      thisParentNode = node.parentNode;
    }
    return null;
  }

  static hasAtributeList(node, attributeList) {
    if (!node || node.nodeType === 3) {
      return false;
    }
    let hasAtributeList = true;
    attributeList.forEach((attribute) => {
      if (
        !node.hasAttribute(attribute.key) ||
        !(node.getAttribute(attribute.key) === attribute.value)
      ) {
        hasAtributeList = false;
      }
    });
    return hasAtributeList;
  }

  /**
   * This function find all descendants of a node with tag = thisTagName
   *
   * @param {DOMNode} thisNode
   * @param {String} thisTagName
   * @return {Array} findChildrenOfType.validDescendants
   * findChildrenOfType.listDescendants
   */
  static findChildrenOfType(thisNode, thisTagName) {
    const node = thisNode;
    const listDescendants = [];
    if (node) {
      let thisDescendant;
      const allDescendants = Array.prototype.slice.call(node.childNodes);
      while (allDescendants.length) {
        thisDescendant = allDescendants.shift();
        if (thisDescendant.nodeType === 1) {
          thisDescendant.childNodes.forEach((element) => {
            allDescendants.push(element);
          });
          listDescendants.push(thisDescendant);
        }
      }
      if (thisTagName) {
        const numberChildren = listDescendants.length;
        const validDescendants = [];
        for (let i = 0; i < numberChildren; i += 1) {
          if (listDescendants[i].tagName === thisTagName) {
            validDescendants.push(listDescendants[i]);
          }
        }
        return validDescendants;
      }
    }
    return listDescendants;
  }

  static getLevel0Id = (node, documentId) => {
    let current = node;
    while (current) {
      if (
        current.nodeType === 1 &&
        current.hasAttribute('parent_id') &&
        current.getAttribute('parent_id') === documentId
      ) {
        return current.id;
      }
      current = current.parentNode;
    }
    return null;
  };

  static getChildNodeFromElement(parent, childIndex, ignoreFrontendOnlyElements = true) {
    if (parent != null && childIndex != null && parent.nodeType === Node.ELEMENT_NODE) {
      let childNodes = Array.from(parent.childNodes);

      if (ignoreFrontendOnlyElements) {
        childNodes = childNodes.reduce((array, child) => {
          if (
            !(
              child.nodeType === Node.ELEMENT_NODE &&
              DOMUtils.INLINE_FRONTEND_ONLY_ELEMENTS.includes(child.tagName)
            )
          ) {
            array.push(child);
          }
          return array;
        }, []);
      }

      return childNodes[childIndex];
    }
    return null;
  }

  /**
   * @deprecated use EditorDOMUtils.findFirstLevelChildNode
   */
  static findNodeLevel0 = (referenceNode, thisNode) => {
    if (!referenceNode || !thisNode) {
      return null;
    }
    if (referenceNode === thisNode || !DOMUtils.parentContainsNode(referenceNode, thisNode)) {
      return null;
    }
    let node = thisNode.nodeType === 3 ? thisNode.parentNode : thisNode;
    while (DOMUtils.parentContainsNode(referenceNode, node.parentNode)) {
      node = node.parentNode;
    }
    return node;
  };

  /**
   * @deprecated use EditorDOMUtils.findPreviousAncestorSibling
   */
  static findPreviousAncestorSibling = (thisNode, parentNode) => {
    if (!parentNode) {
      parentNode = DOMUtils.getPageNode(thisNode);
    }

    let previousSibling;
    if (thisNode && DOMUtils.parentContainsNode(parentNode, thisNode)) {
      let node = thisNode;
      previousSibling = node.previousSibling;

      while (previousSibling == null && DOMUtils.parentContainsNode(parentNode, node.parentNode)) {
        node = node.parentNode;
        previousSibling = node.previousSibling;
      }
    }

    return previousSibling;
  };

  /**
   * @deprecated use EditorDOMUtils.findNextAncestorSibling
   */
  static findNextAncestorSibling = (thisNode, parentNode) => {
    if (!parentNode) {
      parentNode = DOMUtils.getPageNode(thisNode);
    }

    let nextSibling;
    if (thisNode && DOMUtils.parentContainsNode(parentNode, thisNode)) {
      let node = thisNode;
      nextSibling = node.nextSibling;

      while (nextSibling == null && DOMUtils.parentContainsNode(parentNode, node.parentNode)) {
        node = node.parentNode;
        nextSibling = node.nextSibling;
      }
    }

    return nextSibling;
  };

  /**
   * @deprecated use EditorDOMUtils.findPreviousElementSibling
   */
  static findPreviousElementSibling = (thisNode, parentNode) => {
    if (!parentNode) {
      parentNode = DOMUtils.getPageNode(thisNode);
    }

    let node = thisNode;

    if (!node) {
      return null;
    }

    let previousSibling = node.previousElementSibling;

    while (previousSibling === null && DOMUtils.parentContainsNode(parentNode, node.parentNode)) {
      node = node.parentNode;
      previousSibling = node.previousElementSibling;
    }

    return previousSibling;
  };

  /**
   * @deprecated use EditorDOMUtils.findNextElementSibling
   */
  static findNextElementSibling = (thisNode, parentNode) => {
    if (!parentNode) {
      parentNode = DOMUtils.getPageNode(thisNode);
    }

    let node = thisNode;

    if (!node) {
      return null;
    }

    let nextSibling = node.nextElementSibling;

    while (nextSibling === null && DOMUtils.parentContainsNode(parentNode, node.parentNode)) {
      node = node.parentNode;
      nextSibling = node.nextElementSibling;
    }

    return nextSibling;
  };

  static findClosestCitationGroup(anchorNode, anchorOffset) {
    let closestCitationGroup;
    let previousCitationGroup;
    let nextCitationGroup;

    if (anchorNode) {
      // fix selection inside p
      if (
        anchorNode.nodeType === Node.ELEMENT_NODE &&
        (DOMUtils.BLOCK_TEXT_ELEMENTS.includes(anchorNode.tagName) ||
          DOMUtils.INLINE_EDITABLE_ELEMENTS.includes(anchorNode.tagName))
      ) {
        if (anchorNode.childNodes[anchorOffset]) {
          anchorNode = anchorNode.childNodes[anchorOffset];
          anchorOffset = 0;
        } else if (anchorNode.childNodes[anchorOffset - 1]) {
          anchorNode = anchorNode.childNodes[anchorOffset - 1];
          if (anchorNode) {
            anchorOffset =
              anchorNode.nodeType === Node.ELEMENT_NODE
                ? anchorNode.childNodes.length
                : anchorNode.length;
          }
        }
      }

      const getClosestCitationGroup = (node) => {
        const closestElement = DOMUtils.closest(node, [
          ELEMENTS.CitationsGroupElement.TAG,
          ELEMENTS.TrackInsertElement.TAG,
        ]);

        if (closestElement) {
          if (closestElement.tagName === ELEMENTS.CitationsGroupElement.TAG) {
            return closestElement;
          }
          if (
            closestElement.tagName === ELEMENTS.TrackInsertElement.TAG &&
            closestElement.firstChild.tagName === ELEMENTS.CitationsGroupElement.TAG
          ) {
            return closestElement.firstChild;
          }
        }
        return null;
      };

      closestCitationGroup = getClosestCitationGroup(anchorNode);

      if (!closestCitationGroup) {
        const anchorNodeLength =
          anchorNode.nodeType === Node.ELEMENT_NODE
            ? anchorNode.childNodes.length
            : anchorNode.length;

        if (anchorOffset === 0 && anchorNode.previousSibling) {
          previousCitationGroup = getClosestCitationGroup(anchorNode.previousSibling);
        }
        if (anchorOffset === anchorNodeLength && anchorNode.nextSibling) {
          nextCitationGroup = getClosestCitationGroup(anchorNode.nextSibling);
        }
      }
    }

    return closestCitationGroup || previousCitationGroup || nextCitationGroup;
  }

  /**
   * @deprecated use EditorDOMUtils
   */
  static isNodeNonSelectable = (node) => {
    if (node) {
      if (DOMUtils.closest(node, DOMUtils.INLINE_NON_SELECTABLE_ELEMENTS)) {
        return true;
      }
    }
    return false;
  };

  /**
   * @deprecated use EditorDOMElements.isNodeContainerElement
   */
  static isNodeAContainerElement = (node) => {
    if (node && DOMUtils.BLOCK_CONTAINER_ELEMENTS.includes(node.tagName)) {
      if (
        node.tagName === ELEMENTS.TrackInsertElement.TAG ||
        node.tagName === ELEMENTS.TrackDeleteElement.TAG
      ) {
        if (node.displayType === 'BLOCK') {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  };

  /**
   * @deprecated use EditorDOMUtils.isClosestTextElementEditable
   */
  static isNodeEditableTextElement = (node) => {
    const pageNode = DOMUtils.getPageNode(node);
    if (node && node.nodeType !== Node.TEXT_NODE) {
      let closestBlock = DOMUtils.closest(node, DOMUtils.BLOCK_TEXT_ELEMENTS);
      if (closestBlock) {
        if (pageNode.contains(closestBlock) && closestBlock.parentNode !== pageNode) {
          closestBlock = DOMUtils.findNodeLevel0(pageNode, closestBlock);
        }

        if (closestBlock.isEditable) {
          return true;
        }
      }
    }
    return false;
  };

  /**
   * @deprecated use EditorDOMUtils.closestContainerElement
   */
  static closestContainerElement = (node) => {
    let closesContainer;
    let nodeToCheck = node;
    while ((closesContainer = DOMUtils.closest(nodeToCheck, DOMUtils.BLOCK_CONTAINER_ELEMENTS))) {
      if (closesContainer && closesContainer.isContainerElement) {
        return closesContainer;
      }
      nodeToCheck = closesContainer.parentNode;
    }
    return null;
  };

  /**
   * @deprecated use EditorDOMUtils.closestMultiBlockContainerElement
   */
  static closestMultiBlockContainerElement = (node) => {
    let closesContainer;
    let nodeToCheck = node;
    while (
      (closesContainer = DOMUtils.closest(nodeToCheck, DOMUtils.MULTI_BLOCK_CONTAINER_ELEMENTS))
    ) {
      if (closesContainer && closesContainer.isContainerElement) {
        return closesContainer;
      }
      nodeToCheck = closesContainer.parentNode;
    }
    return null;
  };

  /**
   * @deprecated use EditorDOMUtils.isClosestBlockNodeEditable
   */
  static isBlockNodeEditable = (node) => {
    const pageNode = DOMUtils.getPageNode(node);
    if (pageNode && node && node.nodeType !== Node.TEXT_NODE) {
      let closest = DOMUtils.closest(node, DOMUtils.EDITABLE_LEVEL0_ELEMENTS);
      if (closest) {
        if (pageNode.contains(closest) && closest.parentNode !== pageNode) {
          closest = DOMUtils.findNodeLevel0(pageNode, closest);
        }

        if (closest && closest.isEditable) {
          return true;
        }
      }
    }
    return false;
  };

  static isBlockNodeDeletable = (node) => {
    const pageNode = DOMUtils.getPageNode(node);
    if (node && node.nodeType !== Node.TEXT_NODE) {
      let closest = DOMUtils.closest(node, DOMUtils.DELETABLE_LEVEL0_ELEMENTS);
      if (closest) {
        if (pageNode.contains(closest) && closest.parentNode !== pageNode) {
          closest = DOMUtils.findNodeLevel0(pageNode, closest);
        }
        if (closest.isDeletable) {
          return true;
        }
      }
    }
    return false;
  };

  /**
   * @deprecated use EditorDOMUtils
   */
  static isNodeSuggestionParagraphMarker(node) {
    return (
      node &&
      (node.tagName === 'TRACK-DEL-ELEMENT' || node.tagName === 'TRACK-INS-ELEMENT') &&
      !node.isMergeable()
    );
  }

  /**
   * @deprecated use EditorDOMUtils
   */
  static isAtEndOfNode = (parent, node) => {
    if (parent) {
      if (parent.contains(node)) {
        while (parent !== node) {
          if (node !== node.parentNode.lastChild) {
            let nextSibling = node.nextSibling;
            while (nextSibling) {
              if (nextSibling.textContent !== '') {
                return false;
              }
              nextSibling = nextSibling.nextSibling;
            }
          }
          node = node.parentNode;
        }
        return true;
      }
    }
    return false;
  };

  /**
   * @deprecated use EditorDOMUtils
   */
  static isAtStartOfNode = (parent, node) => {
    if (parent) {
      if (parent.contains(node)) {
        while (parent !== node) {
          if (node !== node.parentNode.firstChild) {
            let previousSibling = node.previousSibling;
            while (previousSibling) {
              if (previousSibling.textContent !== '') {
                return false;
              }
              previousSibling = previousSibling.previousSibling;
            }
          }
          node = node.parentNode;
        }
        return true;
      }
    }
    return false;
  };

  /**
   * @deprecated use EditorDOMElements
   * @param {*} node
   * @returns
   */
  static isInlineNode(node) {
    if (node.nodeType === 3) {
      return true;
    }

    if (document.body.contains(node)) {
      const gcs = 'getComputedStyle' in window;
      const cStyle = (gcs ? window.getComputedStyle(node, '') : node.currentStyle).display;
      if (cStyle === 'inline') {
        return true;
      }
    } else {
      const gcs = 'getComputedStyle' in window;
      const t = document.createElement(node.nodeName);
      document.body.appendChild(t);
      const cStyle = (gcs ? window.getComputedStyle(t, '') : t.currentStyle).display;
      document.body.removeChild(t);
      if (cStyle === 'inline') {
        return true;
      }
    }

    return false;
  }

  static cleanAttributes(node, attributes) {
    if (!node || node.nodeType !== 1) {
      return;
    }
    for (let index = 0; index < attributes.length; index++) {
      const element = attributes[index];
      if (node.hasAttribute(element)) {
        node.removeAttribute(element);
      }
    }
  }
}

export default DOMUtils;
